"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var querystring_parser_1 = require("@aws-sdk/querystring-parser");

exports.parseUrl = function (url) {
  var _a = new URL(url),
      hostname = _a.hostname,
      pathname = _a.pathname,
      port = _a.port,
      protocol = _a.protocol,
      search = _a.search;

  var query;

  if (search) {
    query = querystring_parser_1.parseQueryString(search);
  }

  return {
    hostname: hostname,
    port: port ? parseInt(port) : undefined,
    protocol: protocol,
    path: pathname,
    query: query
  };
};